import React from 'react';
import { FormattedMessage } from 'react-intl';

import { FormattedCurrency } from '@/helpers/i18n';

import { useSearchQuery } from '../../../contexts';

import * as S from '../query-tags.styles';

const formatSalary = (salary?: (number | null)[] | null): JSX.Element | '' => {
  if (!salary) return '';

  const filteredSalary = salary.filter((item) => item !== null) as number[];
  return filteredSalary.length === 2 ? (
    <>
      <FormattedCurrency value={salary[0]} currency="EUR" />
      {' – '}
      <FormattedCurrency value={salary[1]} currency="EUR" />
    </>
  ) : (
    ''
  );
};

export const QueryTagSalary: React.FC = () => {
  const {
    queryParams: [{ salary }, setQueryParams],
  } = useSearchQuery();

  const onDelete = (): void => setQueryParams({ salary: undefined });

  const formattedSalary = formatSalary(salary);

  return formattedSalary ? (
    <S.Tag variant="delete" onDelete={onDelete}>
      <FormattedMessage id="SE_FILTER_JOBS_SALARY_LABEL" />: {formattedSalary}
    </S.Tag>
  ) : null;
};
